import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { deleteMember, fetchAllMembers } from '../../lib/membersApi';

export default function MembersList() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setMembers(await fetchAllMembers());
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Remove member "${name}"?`)) return;
    await deleteMember(id);
    load();
  };

  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Members</h1>
          <p className="admin-page-subtitle">Manage member cards on the homepage.</p>
        </div>
        <Link to="/admin/members/new" className="admin-btn-primary">
          + New member
        </Link>
      </div>

      {loading ? (
        <p>Loading…</p>
      ) : members.length === 0 ? (
        <p className="admin-page-subtitle">No members yet.</p>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Logo</th>
                <th>Name</th>
                <th>Order</th>
                <th>Status</th>
                <th className="admin-table__actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              {members.map((member) => (
                <tr key={member.id}>
                  <td>
                    {member.logo_url ? (
                      <img src={member.logo_url} alt="" className="admin-member-thumb" />
                    ) : (
                      <span className="admin-page-subtitle">—</span>
                    )}
                  </td>
                  <td>{member.name}</td>
                  <td>{member.sort_order}</td>
                  <td>
                    <span className={`admin-badge ${member.is_published ? 'admin-badge--published' : 'admin-badge--draft'}`}>
                      {member.is_published ? 'Published' : 'Hidden'}
                    </span>
                  </td>
                  <td className="admin-table__actions">
                    <Link to={`/admin/members/${member.id}`} className="admin-link">Edit</Link>
                    <button type="button" onClick={() => handleDelete(member.id, member.name)} className="admin-link admin-link--danger">
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
